import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Search } from 'semantic-ui-react';
import i18next from 'i18next';

const resultRenderer = ({ cat, title }) => {
    if (!cat) {
        return title;
    }

    return `${cat.key} - ${cat.name} ${cat.note && `(${cat.note})` || ''}`;
};

class SetSubcategory extends Component {
    state = {};

    componentDidMount() {
        this.resetComponent();
    }

    calcSubcategoriesType = () => {
        const { category } = this.props;

        let calced = null;

        if (!category) return 'subcategory';

        if (category.isPrimaryParent) calced = 'primary';
        if (category.subcategories.length || category.items.length) calced = 'subcategory';

        return calced;
    }

    resetComponent = () => this.setState({ isLoading: false, results: [], value: '' })

    handleResultSelect = (e, { result }) => {
        if (!result.cat) {
            this.props.onNewSelected(this.state.value);
        } else {
            this.props.onItemSelected(result.cat);
        }

        this.resetComponent();
    }

    handleSearchChange = (e, { value }) => {
        this.setState({ isLoading: true, value });

        setTimeout(() => {
            if (this.state.value.length < 1) return this.resetComponent();

            const isAvailableCategory = result => {    
                if (result.type === 'upsell') return false;
                if (this.props.category && result.id === this.props.category.id) return false;
                if (result.primaryParentId) return false;
                if (this.props.categories.filter(c => c.primaryParentId === result.id).length) return false;

                const type  = this.calcSubcategoriesType();
                
                if (type) {
                    if (type === 'primary') {
                        return result.type === 'primary';
                    } else {
                        return result.type !== 'primary';
                    }
                }

                return true;
            };

            const re = new RegExp(_.escapeRegExp(this.state.value), 'i');
            const isMatch = result => isAvailableCategory(result) && (re.test(result.name) || re.test(result.key) || re.test(result.note || ''));
            const results = _.filter(this.props.categories, isMatch).map(cat => ({ cat, title: cat.id }));

            this.setState({
                isLoading: false,
                results,
            });
        }, 300);
    }

    render() {
        const { isLoading, value, results } = this.state;

        return (
            <Search
                loading={isLoading}
                onResultSelect={this.handleResultSelect}
                onSearchChange={_.debounce(this.handleSearchChange, 500, { leading: true })}
                results={results}
                value={value}
                resultRenderer={resultRenderer}
                placeholder={i18next.t('menu.setSubcategory')}
                noResultsMessage=""
                fluid
            // {...this.props}
            />
        );
    }
}

SetSubcategory.propTypes = {
    onNewSelected: PropTypes.func,
    onItemSelected: PropTypes.func.isRequired,
    category: PropTypes.object,
    categories: PropTypes.array,
    
};

function mapStateToProps(state) {
    const categories = Object.values(state.businessApp.menu.categories);

    return { categories };
}

export default connect(mapStateToProps)(SetSubcategory);
